import { useEffect, useState } from "react";
import axios from "axios";
import { serverHost } from "../../../../../http_common.js";
import "./terminalActivity.css";

export default function TerminalActivityLog() {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const refresh = () => {
    setLoading(true);
    setError("");
    axios.get(`${serverHost}/unicloud/activity`, { timeout: 20000 })
      .then(({data}) => { if (data?.status !== 200) throw new Error(data?.message || "Activity unavailable"); setActivities(Array.isArray(data.activities) ? data.activities : []); })
      .catch(err => setError(err.response?.data?.message || err.message))
      .finally(() => setLoading(false));
  };
  useEffect(() => { refresh(); }, []);
  return <section className="pos-activity"><div className="fx-ac fx-jb"><h3>Recent activity</h3><button onClick={refresh} disabled={loading}>Refresh</button></div>
    {loading && <p role="status">Loading activity…</p>}{error && <p role="alert" className="pos-inline-error">{error}</p>}
    {!loading && !error && (activities.length ? activities.slice(0,30).map((a,i) => <article key={a._id || a.activityId || i}><strong>{a.heading || a.title || a.type || "Account activity"}</strong><p>{a.description || ""}</p><small>{a.createdAt || a.timestamp ? new Date(a.createdAt || a.timestamp).toLocaleString() : ""}</small></article>) : <p>No recent activity recorded.</p>)}
  </section>;
}
